import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Редактировать комментарий",
    "with-cancel-button": "",
    "confirm-disabled": _ctx.state.is_loading,
    loading: _ctx.state.is_loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_input, {
        placeholder: "Комментарий",
        value: _ctx.state.comment,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.comment.$error,
        "validation-errors": _ctx.state_form$.comment.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["confirm-disabled", "loading", "onSubmit", "onCancel"]))
}